import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, useTheme } from "@mui/material";
import moment from "moment";

import Typography from "components/basic/typography";

import { EVENT_TYPE_MAP } from "../../../../../calendar/eventTypes";
import { Meeting } from "../../../../types";

const DetailLine: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => {
  const theme = useTheme();
  return (
    <Stack direction="row" spacing={2} sx={{ py: 0.5 }}>
      <Typography
        variant="body2"
        style={{ color: theme.palette.text.secondary, width: 130 }}
      >
        {label}
      </Typography>
      <Typography variant="body2" style={{ fontWeight: 500 }}>
        {value}
      </Typography>
    </Stack>
  );
};

const RequestedDetails: React.FC<{ meeting: Meeting }> = ({ meeting }) => {
  const theme = useTheme();
  const { t } = useTranslation("meetings");
  const meta = EVENT_TYPE_MAP[meeting.type];
  const Icon = meta.icon;

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        p: 2,
        mb: 2,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Icon sx={{ color: meta.color, fontSize: 20 }} />
        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
          {t("requested.title")}
        </Typography>
      </Stack>
      <DetailLine label={t("requested.type")} value={meta.label} />
      <DetailLine
        label={t("requested.date")}
        value={moment(meeting.date, "YYYY-MM-DD").format("dddd, MMM D, YYYY")}
      />
      <DetailLine
        label={t("requested.time")}
        value={t("detail.et", {
          time: moment(meeting.from, "HH:mm").format("h:mm A"),
        })}
      />
      {meeting.createdAt && (
        <DetailLine
          label={t("requested.requested")}
          value={
            moment(Number(meeting.createdAt)).isValid() &&
            /^\d+$/.test(String(meeting.createdAt))
              ? moment(Number(meeting.createdAt)).format(
                  "MMM D, YYYY [at] h:mm A",
                )
              : moment(meeting.createdAt).format("MMM D, YYYY [at] h:mm A")
          }
        />
      )}
    </Box>
  );
};

export default RequestedDetails;
